<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/catalogs')" style="cursor: pointer">Catálogos</li>
        <li class="breadcrumb-item active" aria-current="page">Grupos de Familia</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <md-card>
            <md-card-header>
              <div class="md-title">Grupos de Familia
                <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="editGroup='New'">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head>ID</md-table-head>
                  <md-table-head>Nombre</md-table-head>
                  <md-table-head>Descripción</md-table-head>
                  <md-table-head>Plan de Trabajo Predeterminado</md-table-head>
                  <md-table-head>Garantía Legal del Proveedor</md-table-head>
                  <md-table-head style="text-align: center">Editar | Borrar</md-table-head>
                </md-table-row>
                <md-table-row v-if="editGroup==='New'">
                  <md-table-cell>{{editGroup}}</md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Nombre</label>
                      <md-textarea v-model="name" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Descripción</label>
                      <md-textarea v-model="description" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Plan de Trabajo Predeterminado</label>
                      <md-textarea v-model="default_workplan" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell>
                    <md-field>
                      <label>Garantía Legal del Proveedor</label>
                      <md-textarea v-model="supplier_legal_warranty" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell style="width: 16%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarGroup()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-for="family_group in family_groups" :key="family_group.id">
                  <md-table-cell>{{family_group.id}}</md-table-cell>

                  <md-table-cell v-if="editGroup===family_group.id">
                    <md-field>
                      <label>Nombre</label>
                      <md-textarea v-model="name" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{family_group.name}}</md-table-cell>

                  <md-table-cell v-if="editGroup===family_group.id">
                    <md-field>
                      <label>Descripción</label>
                      <md-textarea v-model="description" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{family_group.description}}</md-table-cell>

                  <md-table-cell v-if="editGroup===family_group.id">
                    <md-field>
                      <label>Plan de Trabajo Predeterminado</label>
                      <md-textarea v-model="default_workplan" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{family_group.default_workplan}}</md-table-cell>

                  <md-table-cell v-if="editGroup===family_group.id">
                    <md-field>
                      <label>Garantía Legal del Proveedor</label>
                      <md-textarea v-model="supplier_legal_warranty" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{family_group.supplier_legal_warranty}}</md-table-cell>

                  <md-table-cell style="width: 20%;text-align: center" v-if="editGroup===family_group.id">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarGroup()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                  <md-table-cell v-else style="width: 20%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised md-primary" v-on:click="editarGroup(family_group)">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="borrarGroup(family_group.id)">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

  export default  {
    name: 'family-groups',
    props: [],
    mounted () {
      this.getFamilyGroups();
    },
    data () {
      return {
        family_groups: [],
        editGroup: null,
        name: null,
        description: null,
        default_workplan: null,
        supplier_legal_warranty: null,
      }
    },
    methods: {
      limpiar(){
        this.editGroup = null;
        this.name = null;
        this.description = null;
        this.default_workplan = null;
        this.supplier_legal_warranty = null;
      },
      getFamilyGroups(){
        axios.get( '/api/catalogs/family_groups').then(response => {
          this.family_groups = response.data.data;
        });
      },
      guardarGroup(){
        Vue.toasted.show('Guardando Grupo de Familia...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/family_groups/save', {
          'family_group_id': this.editGroup === 'New' ? -1 : this.editGroup,
          'name': this.name,
          'description': this.description,
          'default_workplan': this.default_workplan,
          'supplier_legal_warranty': this.supplier_legal_warranty,
        }).then(response => {
          this.limpiar();
          this.getFamilyGroups();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Grupo de Familia guardado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editarGroup(group){
        this.editGroup = group.id;
        this.name = group.name;
        this.description = group.description;
        this.default_workplan = group.default_workplan;
        this.supplier_legal_warranty = group.supplier_legal_warranty;
      },
      borrarGroup(gid){
        Vue.toasted.show('Borrando Grupo de Familia...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/family_groups/delete', {
          'family_group_id': gid,
        }).then(response => {
          this.getFamilyGroups();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Grupo de Familia borrado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
    },
}


</script>

<style scoped lang="scss">
  .src-views-admin-catalogs-family-groups {

  }
</style>
